<template>
  <input type="text" class="form-control pull-right" :id="id" :name="id"/>
</template>
<script>
import '../../../static/js/plugins/daterangepicker/daterangepicker'

export default {
  props: ['id', 'startDate', 'endDate'],
  methods: {
    translate (word) {
      return this.$options.filters.translate(word, this.$parent.language)
    },
    go () {
      let input = $('input[name="' + this.id + '"]')
      input.daterangepicker({
        'autoApply': true,
        'startDate': this.startDate,
        'endDate': this.endDate,
        'maxDate': moment(),
        'locale': {
          'format': 'DD-MM-YYYY',
          'applyLabel': this.translate('apply'),
          'cancelLabel': this.translate('cancel'),
          'fromLabel': this.translate('from'),
          'toLabel': this.translate('to')
        }
      })
      input.on('apply.daterangepicker', (ev, picker) => {
        this.$emit('pepe', picker)
      })
    }
  },
  mounted () {
    this.go()
  },
  watch: {
    startDate () {
      this.go()
    },
    endDate () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/DateRangePicker.vue